import { createUniqueID, strToEl } from '../functions/utils';
import { createPopper } from '@popperjs/core';
import InsightTooltip from './InsightTooltip';


export default class InsightEntry {
  constructor(element) {
    this.passedElement = element;
    this.jargonBusterLinks = [];
    this.jargonContainer = document.querySelector('#jargon');
    this.flashcardContent = document.querySelector('#flashcardContent');
    this.tooltips = [];
    this.init();
  }

  init = () => {
    if (!this.initialised) {
      this.initialised = true;
      this.getLinks();
      this.getContentFromJargonBuster();
      this.addTooltipToLinks();
    }
  }


  getLinks = () => {
    let links = this.passedElement.querySelectorAll('a');

    if (links.length) {
      links.forEach((item, i) => {
        const href = item.getAttribute('href');

        if (href.includes('jargon-flashcards#')) {
          // Rewrite href in terms of the current domain to avoid cross-domain calls
          const hrefUrl = new URL(href, window.location.href);
          
          if (hrefUrl.host !== window.location.host) {
            hrefUrl.host = window.location.host;
          }

          item.setAttribute('data-src', hrefUrl.toString());
          item.removeAttribute('href');
          this.jargonBusterLinks.push(item);
          item.addEventListener('click', (e) => {
            if (document.documentElement.clientWidth < 792) {
              e.preventDefault();
            }
          })
        }
      });
    }
  }

  addTooltipToLinks = () => {
    this.jargonBusterLinks.forEach((item, el) => {
      let tooltip = new InsightTooltip(item);
      this.tooltips.push(tooltip);
    })
  }


  getContentFromJargonBuster = () => {
    if (this.jargonBusterLinks.length) {
      let item = this.jargonBusterLinks[0];
      let href = item.getAttribute('data-src');

      let content = fetch(href)
      .then(response => response.text())
      .then(data => {
        this.jargonContainer.innerHTML = data;
        let cards = this.jargonContainer.querySelectorAll('[data-init="jargonBuster"] .flashcard');
        cards.forEach((item, i) => {
          this.flashcardContent.append(item);
        });
        this.jargonContainer.remove();
      });
    }
  }

  addEventListeners = () => {}

  removeEventListeners = () => {}

  dismantle = () => {
    this.removeEventListeners();
    this.passedElement = null;
    this.initialised = false;
  }

}
